import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BreadCrumb } from './breadcrumb.types';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
import { Observable } from 'rxjs';
import { map, filter, distinctUntilChanged, tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { SpinnerService } from '../../_infrastructure/classes/services/spinner.service';
@Component({
    selector: 'app-breadcrumb-cexveg',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
    breadcrumbs$: Observable<BreadCrumb[]> | undefined;
    private breadcrumbsRouting$: Observable<BreadCrumb[]>;
    private breadcrumbsNotify$: Observable<BreadCrumb[]>;
    private storedBreadcrumbsNotify: BreadCrumb[] = new Array<BreadCrumb>();

    // Build your breadcrumb starting with the root route of your current activated route
    constructor(
        private activatedRoute: ActivatedRoute,
        private notificationService: NotificationService,
        private router: Router,
        private spinnerService: SpinnerService,
    ) {}

    ngOnInit() {
        this.initBreadCrumb();
    }

    private initBreadCrumb(): void {
        this.breadcrumbsRouting$ = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            distinctUntilChanged(),
            tap(() => {
                // Al cambiar de ruta, empezamos de nuevo el contador de "llamadas"
                this.spinnerService.resetSpinner();
            }),
            map(() => this.buildBreadCrumb(this.activatedRoute.root)),
        );

        this.breadcrumbsNotify$ = this.notificationService.currentBreadCrumbSource;

        this.breadcrumbs$ = combineLatest([this.breadcrumbsRouting$, this.breadcrumbsNotify$]).pipe(
            map(([f, s]) => {
                if (s[0]) {
                    let br = f.find((t: any) => t.url == s[0].url + '/');
                    if (br) {
                        br.labelParam = s[0].labelParam;

                        if (!this.storedBreadcrumbsNotify.find(t => t.url == br!.url)) {
                            //@adua: para no dejar en el array de guardados muchos. Es un singleton
                            if (this.storedBreadcrumbsNotify.length == this.getStoredBreadCrumbLength()) {
                                this.storedBreadcrumbsNotify.splice(0, 1);
                            }
                            this.storedBreadcrumbsNotify.push(br);
                        }
                    }
                }

                return f;
            }),
        );
    }

    private getStoredBreadCrumbLength(): number {
        return 7;
    }

    private buildBreadCrumb(route: ActivatedRoute, url = '', breadcrumbs: Array<BreadCrumb> = []): Array<BreadCrumb> {
        let newBreadcrumbs: Array<BreadCrumb> = [];

        // In the routeConfig the complete path is not available,
        // so we rebuild it each time
        const nextUrl = `${url}${this.getPath(route)}/`;

        let breadcrumb: BreadCrumb = {
            label: this.getLabel(route),
            labelParam: this.getLabelParam(nextUrl),
            params: this.getParams(route),
            url: this.getUrl(route, nextUrl),
            active: false,
        };

        if (breadcrumb.label != '') {
            let menubreadCrumbs = this.getMenuBreadCrumbs(route);

            if (menubreadCrumbs.length > 0) {
                breadcrumbs = breadcrumbs.concat(menubreadCrumbs);
            }

            newBreadcrumbs = [...breadcrumbs, breadcrumb];
        } else {
            newBreadcrumbs = [...breadcrumbs];
        }

        if (route.firstChild) {
            //chequear esta condicion
            // If we are not on our current path yet,
            // there will be more children to look after, to build our breadcumb
            if (this.getPath(route.firstChild) != '') {
                return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
            }
        }
        newBreadcrumbs.slice(-1)[0].active = true;

        return newBreadcrumbs.filter(s => s.label != undefined);
    }

    private managePublishBreadCrumb(br: BreadCrumb): void {
        // alert(br.labelParam);
    }

    getLabelBreadCrumb(br: BreadCrumb): any {
        if (br.labelParam) {
            return br.label + ' ' + br.labelParam;
        } else {
            return br.label;
        }
    }

    private getParams(route: ActivatedRoute): any {
        if (route.snapshot.paramMap.keys.length > 0) {
            return route.snapshot.params;
        } else {
            return null;
        }
    }

    private getLabel(route: ActivatedRoute): any {
        if (route.routeConfig) {
            if (route.routeConfig.data) {
                //if (route.routeConfig.data['breadcrumb']) {
                return route.routeConfig.data['breadcrumb'];
                //}
                //else {
                //    return '';
                //}
            } else {
                return '';
            }
        } else {
            return 'Inicio';
        }
    }

    private getLabelParam(url: string): any {
        let br = this.storedBreadcrumbsNotify.find(t => t.url == url);

        if (br) {
            return br.labelParam;
        }

        return null;
    }

    private getUrl(route: ActivatedRoute, url: string): any {
        let overridePath = this.getMenuDataKey('overridePath', route);

        if (overridePath.length > 0) {
            return overridePath;
        }

        return url;
    }

    private getPath(route: ActivatedRoute): any {
        if (route.routeConfig) {
            let path = route.snapshot.url
                .filter(s => s.path != '')
                .map(segment => segment.path)
                .join('/');

            return path;
        } else {
            return '';
        }
    }

    private getMenuDataKey(key: string, route: ActivatedRoute): string {
        if (route.routeConfig) {
            if (route.routeConfig.data) {
                if (route.routeConfig.data[key]) {
                    return route.routeConfig.data[key];
                }
            }
        }

        return '';
    }

    private getMenuBreadCrumbs(route: ActivatedRoute): Array<BreadCrumb> {
        let menuEntries: string[] = ['menu0', 'menu1'];

        return menuEntries
            .map(m => {
                let br: BreadCrumb = {
                    label: this.getMenuDataKey(m, route),
                    labelParam: null,
                    params: null,
                    url: '',
                    active: true,
                };

                return br;
            })
            .filter(br => br.label != '');
    }
}
